/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerFindAllQueryResponse, OwnersControllerFindAllQueryParams, OwnersControllerFindAll401, OwnersControllerFindAll403 } from "../../models/ownersController/OwnersControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ownersControllerFindAll } from "../../clients/ownersService/ownersControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ownersControllerFindAllQueryKey = (params: OwnersControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/owners'
}, ...(params ? [params] : [])] as const;
export type OwnersControllerFindAllQueryKey = ReturnType<typeof ownersControllerFindAllQueryKey>;
export function ownersControllerFindAllQueryOptions(params?: OwnersControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ownersControllerFindAllQueryKey(params);
  return queryOptions<OwnersControllerFindAllQueryResponse, ResponseErrorConfig<OwnersControllerFindAll401 | OwnersControllerFindAll403>, OwnersControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ownersControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all owners
 * {@link /api/v1/owners}
 */
export function useOwnersControllerFindAll<TData = OwnersControllerFindAllQueryResponse, TQueryData = OwnersControllerFindAllQueryResponse, TQueryKey extends QueryKey = OwnersControllerFindAllQueryKey>(params?: OwnersControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<OwnersControllerFindAllQueryResponse, ResponseErrorConfig<OwnersControllerFindAll401 | OwnersControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ownersControllerFindAllQueryKey(params);
  const query = useQuery({
    ...ownersControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OwnersControllerFindAll401 | OwnersControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}